import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { WAREHOUSE_BANK_ACTION_TYPE } from '../actions';

const initialState = {};

const warehousesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case WAREHOUSE_BANK_ACTION_TYPE.GET_WAREHOUSE_BANKS:
        return payload || state;

      case WAREHOUSE_BANK_ACTION_TYPE.GET_WAREHOUSE_BANK_LIST:
        payload.forEach(item => {
          if (draft[item.warehouseBankId]) {
            draft[item.warehouseBankId] = item;
          }
        });
        break;

      case WAREHOUSE_BANK_ACTION_TYPE.CREATE_WAREHOUSE_BANK:
      case WAREHOUSE_BANK_ACTION_TYPE.EDIT_WAREHOUSE_BANK:
        draft[payload.warehouseBankId] = payload;
        break;

      case WAREHOUSE_BANK_ACTION_TYPE.DELETE_WAREHOUSE_BANK:
        delete draft[meta.warehouseBankId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default warehousesReducer;
